import { GRID_ROW_NUMBER_COL_DEF } from '@profgeosoft-ui/table';

export const CHECKBOX_SELECTION_COLUMN_FIELD = '__check__';
export const ACTIVITY_COLUMN_FIELD = 'activity';
export const RECORD_BUTTONS_COLUMN = 'record-actions';

export const SERVICE_COLUMNS = [
  '__detail_panel_toggle__',
  GRID_ROW_NUMBER_COL_DEF.field,
  ACTIVITY_COLUMN_FIELD,
  RECORD_BUTTONS_COLUMN,
];
